import { useSelector } from "react-redux";
import { useLocation, Outlet, Navigate } from "react-router-dom";
import { selectUser } from "../features/slices/userSlice";

const RequireAuth = ({ allowedRoles }) => {
  const getUser = useSelector(selectUser);
  const location = useLocation();

  return allowedRoles.includes(getUser?.role) ? (
    <Outlet />
  ) : Object.keys(getUser).length > 0 ? (
    <Navigate to="/unauthorized" state={{ destination: location }} replace />
  ) : (
    <Navigate to="/auth" state={{ destination: location }} replace />
  );
};

export default RequireAuth;
